import { lazy } from 'react';

const LazyTriggerView = lazy(() => import('./trigger-view'));
export default LazyTriggerView;
